export const residentialVocabulary = [
  {
    word: "Illuminate",
    meaning: "비추다, 밝게 하다 (조명이 거실등을 밝힐 때)",
    audioId: 1,
    imageUrl: "/images/vocabulary/residential/home1.png",
  },
  {
    word: "Porch",
    meaning: "현관, 포치",
    audioId: 2,
    imageUrl: "/images/vocabulary/residential/home2.png",
  },
  {
    word: "Steps",
    meaning: "계단",
    audioId: 3,
  },
  {
    word: "Stairs",
    meaning: "계단",
    audioId: 4,
  },
  {
    word: "Pavement",
    meaning: "보도, 인도",
    audioId: 5,
    imageUrl: "/images/vocabulary/residential/home5.png",
  },
  {
    word: "Lawn",
    meaning: "잔디밭",
    audioId: 6,
  },
  {
    word: "Railings",
    meaning: "난간",
    audioId: 7,
  },
  {
    word: "Handrails",
    meaning: "손잡이 난간",
    audioId: 8,
    imageUrl: "/images/vocabulary/residential/home8.png",
  },
  {
    word: "Hallway",
    meaning: "복도",
    audioId: 9,
  },
  {
    word: "Corridor",
    meaning: "복도, 통로",
    audioId: 10,
    imageUrl: "/images/vocabulary/residential/home10.png",
  },
  {
    word: "Lead to",
    meaning: "~로 이어지다",
    audioId: 11,
  },
  {
    word: "Stove",
    meaning: "가스레인지, 인덕션 모두, 장작난로도 포함됨",
    audioId: 12,
  },
  {
    word: "Artwork",
    meaning: "집에 거는 미술작품들 (그림, 액자, 포스터, 벽아트 모두)",
    audioId: 13,
  },
  {
    word: "Countertop",
    meaning: "조리대, 싱크대 상판",
    audioId: 14,
    imageUrl: "/images/vocabulary/residential/home14.png",
  },
  {
    word: "Barstools",
    meaning: "바 의자",
    audioId: 15,
    imageUrl: "/images/vocabulary/residential/home15.png",
  },
  {
    word: "Faucet",
    meaning: "수도꼭지",
    audioId: 16,
    imageUrl: "/images/vocabulary/residential/home16.png",
  },
  {
    word: "Kitchen Utensil",
    meaning: "주방 기구, 조리 도구",
    audioId: 17,
    imageUrl: "/images/vocabulary/residential/home17.png",
  },
  {
    word: "Cookware",
    meaning: "냄비, 프라이팬 같은 조리용품",
    audioId: 18,
    imageUrl: "/images/vocabulary/residential/home18.png",
  },
  {
    word: "Laundry basket",
    meaning: "빨래 바구니",
    audioId: 19,
  },
  {
    word: "Detergent",
    meaning: "세제",
    audioId: 20,
    imageUrl: "/images/vocabulary/residential/home20.png",
  },
  {
    word: "Hangers",
    meaning: "옷걸이",
    audioId: 21,
    imageUrl: "/images/vocabulary/residential/home21.png",
  },
  {
    word: "Drying rack",
    meaning: "건조대 (옷, 그릇 다 포함)",
    audioId: 22,
    imageUrl: "/images/vocabulary/residential/home22.png",
  },
  {
    word: "Sweep",
    meaning: "쓸다, 빗자루로 청소하다",
    audioId: 23,
  },
  {
    word: "Broom",
    meaning: "빗자루",
    audioId: 24,
  },
  {
    word: "Mop",
    meaning: "대걸레질하다",
    audioId: 25,
  },
  {
    word: "Cutlery",
    meaning: "식기류, 수저류",
    audioId: 26,
  },
  {
    word: "Dust",
    meaning: "먼지를 털다",
    audioId: 27,
  },
  {
    word: "Duster",
    meaning: "먼지떨이",
    audioId: 28,
    imageUrl: "/images/vocabulary/residential/home28.png",
  },
  {
    word: "Vacuum",
    meaning: "진공청소하다",
    audioId: 29,
  },
  {
    word: "Tidy up",
    meaning: "정리하다, 치우다",
    audioId: 30,
  },
  {
    word: "Make the bed",
    meaning: "침대 정리하다",
    audioId: 31,
  },
  {
    word: "Lean forward",
    meaning: "앞으로 몸을 기울이다",
    audioId: 32,
  },
  {
    word: "Load",
    meaning: "적재하다, 싣다",
    audioId: 33,
  },
  {
    word: "Kneel",
    meaning: "무릎 꿇다",
    audioId: 34,
  },
  {
    word: "Hang the laundry",
    meaning: "빨래 널다",
    audioId: 35,
  },
  {
    word: "Fireplace",
    meaning: "벽난로",
    audioId: 36,
  },
  {
    word: "Steam",
    meaning: "스팀을 쏘다, 스팀 다리머 사용할 때",
    audioId: 37,
  },
  {
    word: "Press",
    meaning: "다림질하다",
    audioId: 38,
    imageUrl: "/images/vocabulary/residential/home38.png",
  },
  {
    word: "Laundry chores",
    meaning: "세탁 관련 집안일",
    audioId: 39,
  },
  {
    word: "Fold",
    meaning: "접다",
    audioId: 40,
  },
  {
    word: "Patio",
    meaning: "파티오, 테라스",
    audioId: 41,
  },
  {
    word: "Gardening utensil",
    meaning: "정원 도구",
    audioId: 42,
    imageUrl: "/images/vocabulary/residential/home42.png",
  },
  {
    word: "Windowsill",
    meaning: "창턱, 창문받침",
    audioId: 43,
    imageUrl: "/images/vocabulary/residential/home43.png",
  },
  {
    word: "Platter",
    meaning: "큰 접시, 쟁반",
    audioId: 44,
  },
  {
    word: "Vase",
    meaning: "꽃병, 화병",
    audioId: 45,
  },
  {
    word: "Dishware",
    meaning: "식기류(접시, 그릇, 컵 등등)",
    audioId: 46,
    imageUrl: "/images/vocabulary/residential/home46.png",
  },
  {
    word: "Washer",
    meaning: "세탁기",
    audioId: 47,
  },
  {
    word: "Bookcase",
    meaning: "책장, 책꽂이",
    audioId: 48,
  },
  {
    word: "Bin",
    meaning: "쓰레기통, 수납함",
    audioId: 49,
  },
  {
    word: "Frame",
    meaning: "액자, 틀",
    audioId: 50,
  },
  {
    word: "Carpeting",
    meaning: "카펫, 깔개",
    audioId: 51,
  },
  {
    word: "Gardener",
    meaning: "정원사",
    audioId: 52,
  },
  {
    word: "Light switch",
    meaning: "전등 스위치",
    audioId: 53,
  },
  {
    word: "Fastened",
    meaning: "고정된, 묶인",
    audioId: 54,
  },
  {
    word: "Shed",
    meaning: "헛간, 창고",
    audioId: 55,
  },
  {
    word: "Courtyard",
    meaning: "안뜰, 마당",
    audioId: 56,
  },
  {
    word: "Patterned",
    meaning: "무늬가 있는",
    audioId: 57,
  },
  {
    word: "Grip",
    meaning: "잡다, 움켜쥐다",
    audioId: 58,
  },
  {
    word: "Fabric",
    meaning: "직물, 천",
    audioId: 59,
  },
  {
    word: "Pipe",
    meaning: "배관, 파이프",
    audioId: 60,
  },
  {
    word: "Lay",
    meaning: "놓다, 펼치다",
    audioId: 61,
  },
  {
    word: "Knob",
    meaning: "손잡이, 문 손잡이",
    audioId: 62,
  },
  {
    word: "Putting away",
    meaning: "정리하다, 치우다",
    audioId: 63,
  },
  {
    word: "Window frame",
    meaning: "창틀",
    audioId: 64,
  },
  {
    word: "Door frame",
    meaning: "문틀",
    audioId: 65,
  },
  {
    word: "Pillar",
    meaning: "기둥",
    audioId: 66,
  },
  {
    word: "Bowl",
    meaning: "그릇",
    audioId: 67,
  },
  {
    word: "Air-conditioning",
    meaning: "에어컨, 냉방 시스템",
    audioId: 68,
  },
  {
    word: "Draw of curtain",
    meaning: "커튼을 치다, 열다",
    audioId: 69,
  },
  {
    word: "Bend",
    meaning: "구부리다",
    audioId: 70,
  },
  {
    word: "Situate",
    meaning: "위치시키다",
    audioId: 71,
  },
];
